import React from 'react'
import styled from 'styled-components'
import {palette} from 'styled-tools'
import {media} from 'styled-bootstrap-grid'

import type {OrderLine} from 'src/api/saleor/generated'

import {Title6} from 'src/components/typography'
import {formatNumber} from 'src/utils/numbers'

const Wrapper = styled.div`
  padding: 16px 0;
  border-bottom: 1px solid ${palette('black20')};
`

const InfoWrapper = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
`

const InfoLine = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 2fr 1fr;
  justify-content: space-between;
  margin-bottom: 5px;
  width: 100%;

  ${media.md`
  grid-template-rows:1fr;
  grid-template-columns: 3fr 1fr 1fr;
  `}
`

const InfoLineItem = styled.div`
  justify-self: end;

  &:nth-child(n) {
    display: none;
    align-self: end;

    ${media.md`
    display: block;
    `}
  }

  &:first-child {
    display: block;
    justify-self: start;
  }
`

const SkuWrapper = styled.div`
  color: ${palette('black40')};
  font-size: 0.875rem;
  margin-bottom: 5px;
`
const MobileLine = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  padding-top: 14px;
  padding-right: 12px;

  ${media.md`
  display: none;
  `}
`
const MobileLineItem = styled.div`
  justify-self: end;

  &:first-child {
    justify-self: start;
  }
`

interface Props {
  line: OrderLine
}

export default function CheckoutReceiptLine({line}: Props): JSX.Element {
  const {variant, quantity, totalPrice} = line
  const product = variant?.product
  const sku = variant?.sku

  return (
    <Wrapper>
      <InfoWrapper>
        <InfoLine>
          {/* TODO: Add other units than stykki and display total stykki */}
          <InfoLineItem>
            <SkuWrapper>{sku}</SkuWrapper>
            <Title6>{product?.name}</Title6>
          </InfoLineItem>
          <InfoLineItem>{quantity} stk.</InfoLineItem>
          <InfoLineItem>
            {formatNumber(totalPrice?.gross.amount)} kr.
          </InfoLineItem>
          <MobileLine>
            <MobileLineItem>{quantity} stk.</MobileLineItem>
            <MobileLineItem>
              {' '}
              {formatNumber(totalPrice?.gross.amount)} kr.
            </MobileLineItem>
          </MobileLine>
        </InfoLine>
      </InfoWrapper>
    </Wrapper>
  )
}
